import React, { useState, useEffect } from 'react';

// import { Container } from './styles';

import TableNoPagination from '../../Tables/TableBoletoNoPagination';
import api from '@http/api';
import { Grid, IconButton } from '@material-ui/core';

import { CurrencyFormat, FormatDate } from '@utils/formats';
import { FontDownloadOutlined } from '@material-ui/icons';

import { FileDownloadOutlined } from '@mui/icons-material/';
import moment from 'moment';

import { useAuth } from '@hooks/AuthenticateContext';

interface ITest {
  data_cadastro_solicitacao: string;
  campanha: string;
  status_agendamento: string;
  status_recorrencia:  string;
  data_inicio_contrato: string;
  pixCopiaECola: string;
  linkQrCode: string;

}

interface IProps {
  idPerfil: number;
}

const TabelaBoletos: React.FC<IProps> = ({ idPerfil }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ITest[]>([]);
  const [total, setTotal] = useState<number>(0);

  const columnsLabel = {
    data_cadastro_solicitacao: 'Data cadastro',
    campanha: 'Campanha',
    status_agendamento: 'Agendamento',
    status_recorrencia:  'Recorrência',
    data_inicio_contrato: 'Vencimento',
    pixCopiaECola: 'Copia e cola',
  };

  useEffect(() => {
    async function loadData() {
      setLoading(true);
      await api
        .get(`api/Historico/GetPixAutomaticoPerfil/${idPerfil}`)
        .then(response => {
          const items = response.data;
          setTotal(response.data.total_doacoes);
          var itemData: ITest[] = [];

          items.map((item: ITest) => {
            console.log(item);
            return itemData.push({
              data_cadastro_solicitacao: item.data_cadastro_solicitacao,
              campanha: item.campanha,
              status_agendamento: item.status_agendamento,
              status_recorrencia: item.status_recorrencia,
              data_inicio_contrato: item.data_inicio_contrato,
              pixCopiaECola: item.pixCopiaECola,
              linkQrCode: item.linkQrCode,
            });
          });

          setData(itemData);
          setLoading(false);
        })
        .catch(error => {
          alert(error);
        });
    }

    loadData();
  }, [idPerfil]);

  const { user, signOut } = useAuth();

    //Bloqueio inspecionar
      useEffect(() => {
     if (user.role !== 'ADM SOCIALLIS') {
       const handleKeyDown = (event: KeyboardEvent) => {
         if (event.key === 'F12') {
           event.preventDefault();
           alert('F12 está desativado.');
         }
         if (event.ctrlKey && event.shiftKey && event.key === 'I') {
           event.preventDefault();
           alert('Ctrl+Shift+I está desativado.');
         }
         if (event.ctrlKey && event.shiftKey && event.key === 'J') {
           event.preventDefault();
           alert('Ctrl+Shift+J está desativado.');
         }
         if (event.ctrlKey && event.key === 'U') {
           event.preventDefault();
           alert('Ctrl+U está desativado.');
         }
       };

       const detectDevTools = () => {
         const threshold = 160;
         const widthThreshold = window.outerWidth - window.innerWidth > threshold;
         const heightThreshold = window.outerHeight - window.innerHeight > threshold;

         if (widthThreshold || heightThreshold) {
           alert('Ferramentas de desenvolvedor detectadas.');
           window.location.href = '/';
         }
       };

       const interval = setInterval(detectDevTools, 1000);

       document.addEventListener('keydown', handleKeyDown);

       return () => {
         document.removeEventListener('keydown', handleKeyDown);
         clearInterval(interval);
       };
     }
   }, [user.role]);

  return (
    <TableNoPagination
      loading={loading}
      columns={[columnsLabel]}
      data={data}
      keys={['data_cadastro_solicitacao','campanha', 'status_agendamento', 'status_recorrencia', 'data_inicio_contrato',  'pixCopiaECola']}
      ActionHeader="Ação"
      Actions={[
        {
          Button: (row: ITest) => {
            if (row.linkQrCode) {
              return (
                <IconButton
                  aria-label="download"
                  onClick={() => {
                    window.open(row.linkQrCode, '_blank');
                  }}
                >
                  <FileDownloadOutlined />
                </IconButton>
              );
            } else {
              return (
                <IconButton
                  aria-label="download"
                  onClick={() => {
                    window.open(row.linkQrCode, '_blank');
                  }}
                  disabled
                >
                  <FontDownloadOutlined />
                </IconButton>
              );
            }
          },
        },
      ]}
    />
  );
};

export default TabelaBoletos;
